const liveUrl = "https://elearning.magnusfilmacademy.com";
// const devUrl = "http://localhost/elearning/src";
const baseUrl = liveUrl;
export { baseUrl };
